import styled from '@emotion/styled';
import {colors} from 'patient-ping-remedy/packages/theme';

const avatarWrapperStyle = {
  borderRadius: '50%',
  overflow: 'hidden',
  background: colors.white,
};

export const avatarStyle = {
  height: '3.6rem',
  width: '3.6rem',
  minWidth: '3.6rem',
};

export const AvatarWrapper = styled.div({
  ...avatarWrapperStyle,
  ...avatarStyle,
});

export const AvatarCircle = styled.div((props: { color: string }) => ({
  ...avatarWrapperStyle,
  ...avatarStyle,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  background: props.color,
  '& > svg': {
    fontSize: '1.6rem',
  },
}));
